<div class="overflow-y-auto" style="max-height: 150pt;">
    <ul class="ml-8">
        @if(serialNumbers().length > 0) {
            @for(serial of serialNumbers(); track serial) {
                <li>{{serial}}</li>
            }
        }
        @else {
            <li>{{ 'document-line-item.no-serial-numbers' | translate }}</li>
        }
    </ul>

    @if(serialNumbers().length == 0) {
        <p-button [link]="true" [loading]="loading()"
                [label]="'common.refresh' | translate"
                (click)="getData()" 
            />
    }
    @else if((totalSerialNumberCount() > 0 && serialNumbers().length < totalSerialNumberCount()) || totalSerialNumberCount() === -1) {
        <p-button [link]="true" [loading]="loading()"
            [label]="totalSerialNumberCount() === -1 ? ('document-line-item.load-all-serial-numbers' | translate)
                : ('document-line-item.load-all-count-serial-numbers' | translate: { count: totalSerialNumberCount() })"
            (click)="getData(totalSerialNumberCount())" 
        />
    }
</div>